import { FC, useRef } from "react";
import styled from "styled-components";

// Insights Iframe URL
const INSIGHTS_URL =
  "https://prod-apsoutheast-a.online.tableau.com/t/analyticsxiq/views/MarketingReports/Home?:embed=y&:tabs=no&:toolbar=no";

const CustomReports: FC = () => {
  const journeyFrame = useRef<HTMLIFrameElement>(null);

  return (
    <>
      <Wrapper>
        <iframe src={INSIGHTS_URL} ref={journeyFrame} />
      </Wrapper>
    </>
  );
};

export default CustomReports;
const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  iframe {
    width: 100%;
    height: calc(100vh - 170px);
    margin-top: 16px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: calc(100vh - 130px);
    }
  }
`;
